import { CopyInput } from 'foundations-components/transitional/components/CopyInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { ACTIONS, EVENTS, SCREENS } from '../../../constants/tracking';
import { useApp } from '../../../contexts/AppContext';
import { useTracking } from '../../../contexts/TrackingContext';
import { jsx as _jsx } from "react/jsx-runtime";
export function EnterpriseManagedAuthAccountId({
  label,
  value,
  helpText,
  hasBottomMargin = false
}) {
  const {
    appId,
    appName
  } = useApp();
  const {
    track
  } = useTracking();
  return /*#__PURE__*/_jsx(FormControl, {
    label: label,
    help: helpText,
    marginBlockEnd: hasBottomMargin ? '400' : undefined,
    children: /*#__PURE__*/_jsx(CopyInput, {
      value: value,
      onCopy: () => track(EVENTS.PANEL_INTERACTED, {
        screen: SCREENS.MANAGEMENT_MODAL_PANEL,
        action: ACTIONS.EMA_ACCOUNT_ID_COPIED,
        appId,
        appName
      })
    })
  });
}